import { createFileRoute } from '@tanstack/react-router';

type ReturnSearchParams = {
  tab?: string;
  q?: string;
  page?: number;
};

export const Route = createFileRoute('/orders/returns/')({
  validateSearch: (search: Record<string, unknown>): ReturnSearchParams => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
  }),
});
